export default "__VITE_ASSET__DY4BIlEf__"